const NAV_THEME_STORAGE_KEY = 'app_nav_theme';

export const saveNavTheme = (theme: 'light' | 'realDark') => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(NAV_THEME_STORAGE_KEY, theme);
};
